module.exports = __webpack_public_path__ + "static/media/oberflex-noyerameriquet160-1200x2490.ac49b700.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-noyerameriquet160-1200x2490.jpg
// module id = 1038
// module chunks = 37